module.exports = __webpack_public_path__ + "static/img/glw-logo.89ff5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glw-logo.png
// module id = G5oS
// module chunks = 52